// Lightweight access to the logged-in user's role names.
//
// The login response reliably includes the user's full role set, so we stash the
// role names in localStorage at sign-in. This is more dependable than the profile
// endpoint (whose roles are lazy-loaded and can come back empty). userLogout()
// runs localStorage.clear(), so this is cleared automatically on logout.

const ROLES_KEY = "ftUserRoles";

export const ROLE_REFERRAL_PARTNER = "ReferralPartner";
export const ROLE_CLIENT = "User";

/** Persist role names from the login response, e.g. [{name:"User"}, ...]. */
export function persistUserRoles(roles) {
  try {
    const names = (roles || []).map((r) => r?.name).filter(Boolean);
    localStorage.setItem(ROLES_KEY, JSON.stringify(names));
  } catch {
    /* localStorage unavailable — toggles just won't show */
  }
}

/** Current user's role names (empty array if none stored). */
export function getUserRoleNames() {
  try {
    const raw = localStorage.getItem(ROLES_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function hasRole(name) {
  return getUserRoleNames().includes(name);
}
